import './style/index.scss'
import Vue from 'vue'
import App from './App.vue'
import './utils/flexible.js'
import * as Sentry from '@dida-sentry/h5'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'
import { BsGetEnv, VnToast, VnLoginToast, BsSetWebp, BsAjax, BsGetcapis, BsGetCid, BsUtil, BsGetXcx } from 'dida-web-common'
import zenus from './zeusComponent/index'
import _shareInit from './utils/share.js'
import track from './utils/track.js'
import DATA from './config.js'
import routerset from './utils/routerset.js'
// 获取页面路由
const name = DATA.shareData.prodectName
let router = location.pathname.replace(`/${name}/`, '').split('/')
// 如果路由只有一个元素且不为空，获取该路由，否则设置为 'default'
router = (router.length === 1 && router[0]) ? router[0] : 'default'
// 刷新页面时，设置路由为 'default' 并返回上一个页面
if (/refresh$/.test(router)) {
    router = 'default'
    history.go(-1)
}
// 禁用浏览器的滚动位置恢复功能
if (history.scrollRestoration) {
    history.scrollRestoration = 'manual'
}

if (DATA?.options?.basic?.autoRefresh) {
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible') {
            location.reload()
        }
    })
}
Vue.use(VnToast)
zenus(Vue)
const _mainThread = async(activeData) => {
     // 初始化 Webp 支持
    const isSuWebp = await BsSetWebp.init(Vue)
    // Vue 全局配置
    Vue.config.productionTip = false
    Vue.prototype.$track = await track(name, activeData?.sceneCode, activeData?.activityCode && Array.isArray(activeData?.activityCode) ? activeData?.activityCode[0] : activeData?.activityCode)
    Vue.prototype.DATA = DATA
    Vue.prototype.$bus = new Vue({ 'data': () => ({ 'store': {}}) })
    // 创建 Vue 实例
    const _v = new Vue({
        data: () => ({
            componentsLoaded: false,
            componentsMap: {},
            emitList: {}, // 存储页面事件
            closeLoading: false, // 关闭页面弹窗
            pageRouter: {}, // 页面路由集合
            currentRouter: router, // 页面路由
            productName: name, // 项目名称
            shareData: DATA?.shareData, // 分享数据
            activeData, // 活动数据
            isSuWebp,
            historyLength: window.history.length,
            updateInitData(acCode, acType) {
                getActiveData(_v, acCode, acType)
            }
        }),
        'render': (h) => h(App),
        'methods': {
            updateComponentsListener(compList = []) {
                compList.forEach((comp) => {
                    Object.defineProperty(window, comp, {
                        get() {
                            return _v.componentsMap[comp]
                        },
                        'set': (v) => {
                            Vue.set(_v.componentsMap, comp, v)
                        },
                        'enumerable': true,
                        'configurable': true
                    })
                })
            },
            getCompNameCollection(data = []) {
                const compSet = new Set()
                const dfs = (cps) => {
                    cps.forEach((cp) => {
                        if (cp.type === 'group') {
                            dfs(cp.children)
                        } else if (!window[cp.type]) {
                            compSet.add(cp.type)
                        }
                    })
                }
                data.forEach(({ components = [] }) => {
                    dfs(components)
                })

                return [...compSet]
            }
        }
    }).$mount('#appRender')
    // 登录功能
    // eslint-disable-next-line no-unexpected-multiline
    Vue.prototype.$Login = function(cb) {
        const autoRefresh = DATA?.options?.basic?.autoReload
        VnLoginToast.vnLogin({
            autoRefresh: !!autoRefresh,
            success: (user) => {
                cb && cb(user)
                _v.$track.addStat('h5_will_enter_page')
                _v.$bus.$emit('logined', { ...user })
                getActiveData(_v)
            }
        })
    };
     /* **** 组件加载 **** */
     // 加载组件及分享初始化
    (async() => {
        const _DATA = [...(DATA?.pageData || []), ...(DATA?.fixedData || [])]
        if (DATA) {
            _v.updateComponentsListener(_v.getCompNameCollection(_DATA))
        }
        _v.$set(_v.$data, 'componentsLoaded', true)
        routerset(_v, function() {
            DATA && DATA.shareData && _shareInit(DATA?.shareData, DATA?.options.basic.itemTypes)
        })
    })()
    /* **** End **** */
}
function setPage(page, hasMelete) {
    var { groupAll } = DATA.melete
    const showPage = []
    // 遍历当前页的所有元素
    function pipeiMelete(melete) {
        for (let y = 0; y < melete.length; y++) {
            if (hasMelete.indexOf(melete[y]) > -1 || melete[y] == -1) {
                return true
            }
        }
        return false
    }
    groupAll[page].forEach(item => {
        if (item.type === 'default') {
            showPage.push(item.number) // 默认类型直接添加
        } else if (item.type === 'group') {
           for (let j = 0; j < item.list.length; j++) {
                const { melete, number } = item.list[j]
                if (pipeiMelete(melete)) {
                    showPage.push(number)
                    break
                }
                if (j === item.list.length - 1) {
                    showPage.push(number)
                }
           }
        }
    })
    // 根据 showPage 中的页码获取相应的数据
    const defaultData = DATA[page]
    const pageData = showPage.map(item => defaultData[item])
    // 更新 DATA[page] 数据
    DATA[page] = pageData
}
async function getActiveData(_v, acCode, acType) {
    const { cid } = await BsGetCid()
    const { isWx } = await BsGetXcx()
    const { promotionId, promotionCode, url, activityType, params, activityCode, guestUrl } = DATA.options.basic?.getDataMes || DATA.options.basic

    if (promotionId) {
        let AcCode = activityCode
        let urls = url
        let requestData = {
            ...(params || {}),
            userCid: cid,
            terminalType: activityType === 5 ? 4 : (isWx ? 'MINI_PG' : 'APP')
        }
        if (acCode) {
            requestData.activityCode = acCode
        }
        if (acType) {
            requestData.activityTemplateType = acType
        }
        if (activityType === 5 && router === 'guest') {
            requestData.shareCode = BsUtil.queryString('shareCode')
            AcCode = params.activityCode
            urls = guestUrl
        }

        // 裂变预判需要转formDATA
        requestData = activityType === 5 ? BsUtil.stringify(requestData) : requestData
        await BsAjax({
            method: activityType === 5 ? 'POST' : 'GET',
            url: BsGetcapis + '/web' + (urls || '/activity-platform/promotion/act/predict'),
            [activityType === 5 ? 'data' : 'params']: requestData
        }).then((res) => {
            const activityList = {
                sceneCode: promotionCode, // 奖励明细使用，埋点也用
                activityCode: AcCode // 埋点，请求---裂变数组，第二个是阶梯
            }
            let hasMelete = []
            if (activityType !== 'dacu') {
                const data = res.data
                activityList.promotionStatus = data?.data?.errorCode || data?.code
                activityList[ activityType ] = [{
                    activityCode: activityCode,
                    activityInfo: data?.data,
                    code: data?.data?.errorCode || data?.code,
                    msg: data?.data?.errorMsg || data?.message
                }]
            } else {
                const { map } = res.data
                hasMelete = map?.data?.hitUserGroup || []
                activityList.promotionStatus = map?.code === undefined ? res.data.code : map?.code // 判断整体状态
                try {
                    if (map?.data) {
                        const activityTemplateList = map?.data?.activityTemplateList
                        activityTemplateList.forEach(item => { // 子活动
                            item.activityList.forEach(u => {
                                if (u && u.activityInfo && BsUtil.isString(u.activityInfo)) {
                                    try {
                                        u.activityInfo = JSON.parse(u.activityInfo) || {}
                                    } catch (error) {
                                        u.activityInfo = {}
                                    }
                                }

                                const acType = item.activityTemplateType
                                const acLocation = u?.locationCode ? (item.activityTemplateType + '_' + u?.locationCode) : undefined
                                activityList[acType] ? activityList[acType].push(u)
                                : (activityList[acType] = [u])
                                if (acLocation) {
                                    activityList[acLocation] ? activityList[acLocation].push(u)
                                    : (activityList[acLocation] = [u])
                                }
                            })
                        })
                    }
                } catch (error) {
                    console.error(error)
                    this.$didafe?.toast(res.data.message || '网络异常')
                }
            }

            if (_v) {
                if (acCode || acType) {
                    Object.keys(activityList).forEach(keys => {
                        _v.$set(_v.$data.activeData, keys, activityList[keys])
                    })
                } else {
                    _v.$set(_v.$data, 'activeData', activityList)
                }

                // _v.$bus.$emit('updateActiveDate')
                // this.$bus.$on('updateActiveDate', () => {})
            } else {
                activityList.melete = hasMelete
                setPage('pageData', hasMelete)
                setPage('fixedData', hasMelete)
                _mainThread(activityList)
            }
        })
    } else if (!_v) {
        _mainThread()
    }
    _v && _v.$bus.$emit('updateActiveDate')
}

(() => {
    const autoLogin = DATA?.options?.basic?.autoLogin
    const autoRefresh = DATA?.options?.basic?.autoReload
    if (autoLogin === false) {
        VnLoginToast.vnLogin({
            autoRefresh: !!autoRefresh,
            success: () => {
                getActiveData()
            }
        })
    } else {
        getActiveData()
    }

    // await _loadInit()
    DATA && DATA.shareData && _shareInit(DATA?.shareData)
    if (DATA.options && DATA.options.basic.sentry) {
        Sentry.init({
          Vue,
          release: packageInfo.name + '@' + packageInfo.version,
          environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
          dsn: DATA.options.basic.sentry,
          integrations: [
            new BrowserTracing({
            //   routingInstrumentation: Sentry.vueRouterInstrumentation(router),
              tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
            })
          ],
          tracesSampleRate: 1.0
        })
      }
})()
